import { Card, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Tooltip from 'components/InfoTip'
import Typoleton from 'components/container/Typoleton'
import RiskRatioBar from 'components/RiskRatioBar'
import { toA } from 'utils/display'
import { infoModalKind } from 'components/Modal/InfoModal'
import { ReactNode } from 'react'
import { CardTVL } from 'components/TVL'
import { observer } from 'mobx-react-lite'
import { poolStore } from 'stores'
import { poolService } from 'services/poolService'
import { ZERO } from 'constants/number'

interface MiniCardProps {
  title: string
  toolTip?: infoModalKind
  body: ReactNode
}
const MiniCard = ({ title, toolTip, body }: MiniCardProps) => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'left',
        border: 'none',
      }}
    >
      <Box display="flex" alignItems="center">
        <Typography variant="caption"> {title} </Typography>
        {toolTip && <Tooltip kind={toolTip} />}
      </Box>
      <Box>{body}</Box>
    </Card>
  )
}

const AccountInfoCard = observer(() => {
  const poolAddr = poolService.poolAddress
  const pool = poolStore.getPool(poolAddr)
  const RiskRatio = pool.walletCollateralValueUSD?.eq(ZERO)
    ? ZERO
    : pool.walletTotalDebtValueUSD
        ?.div(pool.walletCollateralValueUSD || 1)
        .times(100)

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item sm={12} md={8}>
          <Card>
            <Typography
              variant="h6"
              mb="22px"
              width="min-content"
              whiteSpace="nowrap"
            >
              My position
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <MiniCard
                  title="Total supply balance"
                  body={
                    <Typoleton
                      variant="h5"
                      prefix="$"
                      data={toA(pool.walletAllSupplyBalUSD)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MiniCard
                  title="Total borrow balance"
                  body={
                    <Typoleton
                      variant="h5"
                      prefix="$"
                      data={toA(pool.walletAllBorrowBalUSD)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MiniCard
                  title="Net APY"
                  body={
                    <Typoleton
                      variant="h5"
                      suffix="%"
                      data={toA(pool.walletNetAPY)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <MiniCard
                  title="Borrowing power left"
                  toolTip="Borrowing power"
                  body={
                    <Typoleton
                      variant="h5"
                      prefix="$"
                      data={toA(pool.walletBorrowingPowerUSD)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <MiniCard
                  title="Risk ratio"
                  toolTip="Risk Ratio"
                  body={
                    <Box mt="-30px">
                      <RiskRatioBar RiskRatio={RiskRatio} />
                    </Box>
                  }
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardTVL />
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
})

export default AccountInfoCard
